module.exports = __webpack_public_path__ + "img/Y2403.900faea9.jpeg";